import {ITask, ITaskDetail} from "../../models/tasks/tasks.interface";

export interface ITasksListState {
  data: Array<ITask>;
  isLoaded: boolean;
}
export const initialTasksListState:ITasksListState = {
  data: [],
  isLoaded: false
};

export interface ITaskDetailState {
  data: ITaskDetail;
  isLoaded: boolean;
}
export const initialTaskDetailState:ITaskDetailState = {
  data: {
    rid: '',
    partyId: '',
    partyName: '',
    dateSubmited: '', //В формате YYYYMMDD hh24:mi:ss
    dateStarted: '', //В формате YYYYMMDD hh24:mi:ss
    dateExecuted: '', //В формате YYYYMMDD hh24:mi:ss
    statusCode: '',
    errorCode: '',
    url: '',
    fileType: '',
    operationCode: '',
    operationName: '',
    description: '',
    operationProfile: null

  },
  isLoaded: false
};

export interface ITasksState {
  tasksList: ITasksListState;
  taskDetail: ITaskDetailState;
}

export const initialTasksState: ITasksState = {
  tasksList: initialTasksListState,
  taskDetail: initialTaskDetailState
};
